import { createMuiTheme } from '@material-ui/core';

export const defaultTheme = createMuiTheme();
